import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import BoundOperation from "core/models/BoundOperation";
var BoundOperationSet = Backbone.Collection.extend({
  model: BoundOperation,

  initialize: function (models, options) {
    Backbone.Collection.prototype.initialize.apply(this, arguments);

    options = options || {};

    this.parent = options.parent;
  },

  /**
   * Gets the original collection of unbound operations which generated this set.
   * @return {OperationSet} The original collection.
   */
  unbindAll: function () {
    return this.parent;
  },
});

export default BoundOperationSet;



//////////////////
// WEBPACK FOOTER
// ./public/js/core/models/BoundOperationSet.js
// module id = 212
// module chunks = 1